import { $UpdateOrganizationPromptModelBodyDto } from 'app/API/schemas';
import { TReasoningEffort } from '../types/TReasoningEffort';

export const REASONING_EFFORTS: readonly TReasoningEffort[] =
  $UpdateOrganizationPromptModelBodyDto.properties.reasoningEffort.enum;

export const isReasoningEffort = (value: string): value is TReasoningEffort =>
  REASONING_EFFORTS.some((effort) => effort === value);
